import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  CountryName: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  Upload: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type CreateMarketplaceItemInput = {
  bereavement?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['ID']['input'];
  condition: MarketplaceItemCondition;
  delivery?: InputMaybe<MarketplaceItemDelivery>;
  description: Scalars['String']['input'];
  expiresOn?: InputMaybe<Scalars['DateTime']['input']>;
  images: Array<Scalars['Upload']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateSosInput = {
  distance: Scalars['Int']['input'];
  latitude: Scalars['Float']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  longitude: Scalars['Float']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  why: SosWhy;
};

export type EditMarketplaceItemInput = {
  bereavement?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['ID']['input'];
  condition: MarketplaceItemCondition;
  delivery?: InputMaybe<MarketplaceItemDelivery>;
  description: Scalars['String']['input'];
  expiresOn?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  images: Array<MarketplaceItemImage>;
  imagesNew: Array<Scalars['Upload']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type EditSosInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type Inquiry = {
  __typename?: 'Inquiry';
  advert_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type MarketplaceCategory = {
  __typename?: 'MarketplaceCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MarketplaceItem = {
  __typename?: 'MarketplaceItem';
  bereavement: Scalars['Boolean']['output'];
  category?: Maybe<MarketplaceCategory>;
  condition: MarketplaceItemCondition;
  createdAt: Scalars['DateTime']['output'];
  deleteAt: Scalars['DateTime']['output'];
  delivery?: Maybe<MarketplaceItemDelivery>;
  description: Scalars['String']['output'];
  expiresOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<Image>>;
  isPaymentNeeded?: Maybe<Scalars['Boolean']['output']>;
  isRenewable?: Maybe<Scalars['Boolean']['output']>;
  listingDate?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  paidPrice?: Maybe<Scalars['Int']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  status: MarketplaceItemStatus;
  title: Scalars['String']['output'];
};

export enum MarketplaceItemCondition {
  LikeNew = 'LIKE_NEW',
  New = 'NEW',
  Unopened = 'UNOPENED',
  Used = 'USED'
}

export enum MarketplaceItemDelivery {
  Collection = 'COLLECTION',
  Included = 'INCLUDED',
  NotIncluded = 'NOT_INCLUDED'
}

export type MarketplaceItemImage = {
  id: Scalars['ID']['input'];
};

export enum MarketplaceItemStatus {
  Approved = 'APPROVED',
  ChangeRequired = 'CHANGE_REQUIRED',
  New = 'NEW'
}

export type MarketplaceItemsFilterInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  isItemPaid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  status: MarketplaceItemStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveMarketplaceItem?: Maybe<MarketplaceItem>;
  approveSos?: Maybe<Sos>;
  checkoutMarketplaceItem: Scalars['String']['output'];
  checkoutSos: Scalars['String']['output'];
  createMarketplaceItem: MarketplaceItem;
  createSos?: Maybe<Sos>;
  deleteMarketplaceItem?: Maybe<MarketplaceItem>;
  deleteMarketplaceItemAsAdmin?: Maybe<MarketplaceItem>;
  deleteMe?: Maybe<Scalars['Boolean']['output']>;
  deleteSos?: Maybe<Sos>;
  editMarketplaceItem: MarketplaceItem;
  editSos?: Maybe<Sos>;
  favouriteMarketplaceItem?: Maybe<User>;
  forgotPassword?: Maybe<Scalars['Boolean']['output']>;
  getFee: Scalars['Float']['output'];
  login?: Maybe<User>;
  logout: Scalars['Boolean']['output'];
  paidMarketplaceItem: Scalars['Int']['output'];
  paidSos: Scalars['Int']['output'];
  refund?: Maybe<Sos>;
  refundRequest?: Maybe<Sos>;
  rejectMarketplaceItem?: Maybe<MarketplaceItem>;
  rejectSos?: Maybe<Sos>;
  relistMarketplaceItem?: Maybe<MarketplaceItem>;
  removeFavouriteMarketplaceItem?: Maybe<User>;
  renewMarketplaceItem?: Maybe<MarketplaceItem>;
  resendVerifyEmail?: Maybe<Scalars['Boolean']['output']>;
  resendVerifyMobile?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  sendMarketplaceItemContactMessage: Scalars['Boolean']['output'];
  signUp?: Maybe<User>;
  submitSosSurvey: Scalars['Boolean']['output'];
  updateMe?: Maybe<User>;
  updateStatus?: Maybe<User>;
  verifyEmail?: Maybe<Scalars['Boolean']['output']>;
  verifyMobile?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationApproveMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveSosArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCheckoutMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCheckoutSosArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateMarketplaceItemArgs = {
  input: CreateMarketplaceItemInput;
};


export type MutationCreateSosArgs = {
  input: CreateSosInput;
};


export type MutationDeleteMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMarketplaceItemAsAdminArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeleteSosArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditMarketplaceItemArgs = {
  input: EditMarketplaceItemInput;
};


export type MutationEditSosArgs = {
  input: EditSosInput;
};


export type MutationFavouriteMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGetFeeArgs = {
  price: Scalars['Float']['input'];
};


export type MutationLoginArgs = {
  browser_name: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  password: Scalars['String']['input'];
  postal_code: Scalars['String']['input'];
  visitor_id: Scalars['String']['input'];
};


export type MutationPaidMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
  session: Scalars['String']['input'];
  session_id: Scalars['String']['input'];
};


export type MutationPaidSosArgs = {
  id: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
  session: Scalars['String']['input'];
  session_id: Scalars['String']['input'];
};


export type MutationRefundArgs = {
  id: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationRefundRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectMarketplaceItemArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectSosArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRelistMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFavouriteMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenewMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendMarketplaceItemContactMessageArgs = {
  input: SendMarketplaceItemContactMessageInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSubmitSosSurveyArgs = {
  feedback: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateStatusArgs = {
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyMobileArgs = {
  code: Scalars['String']['input'];
};

export type PaymentBreakdown = {
  __typename?: 'PaymentBreakdown';
  cardFee: Scalars['Float']['output'];
  potntialTotal: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
  smsCost: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  twillioGbp: Scalars['Float']['output'];
  twilllioFee: Scalars['Float']['output'];
  twilllioSellingFee: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAllByUserIdEnquiries?: Maybe<Array<Maybe<Inquiry>>>;
  getUsersList?: Maybe<Array<Maybe<User>>>;
  marketplaceCategories: Array<MarketplaceCategory>;
  marketplaceItem?: Maybe<MarketplaceItem>;
  marketplaceItems: Array<MarketplaceItem>;
  me?: Maybe<User>;
  productEnquiries?: Maybe<Array<ProductEnquiries>>;
  publicMarketplaceItems: Array<MarketplaceItem>;
  sos: Array<Sos>;
  sosById?: Maybe<Sos>;
  sosByStatus: Array<Sos>;
  sosCost?: Maybe<Scalars['Float']['output']>;
  sosCount?: Maybe<Scalars['Int']['output']>;
  sosCountDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sosCountMonths?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sosGetAllByUserIdMessages?: Maybe<Array<Maybe<SosMessage>>>;
  sosUserMessages?: Maybe<Array<UserMessages>>;
  userEnquiries?: Maybe<Array<UserEnquiries>>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  usersCountDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  usersCountMonths?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};


export type QueryGetAllByUserIdEnquiriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGetUsersListArgs = {
  filter?: InputMaybe<UserFilterInput>;
};


export type QueryMarketplaceItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketplaceItemsArgs = {
  filter?: InputMaybe<MarketplaceItemsFilterInput>;
};


export type QueryPublicMarketplaceItemsArgs = {
  filter?: InputMaybe<MarketplaceItemsFilterInput>;
};


export type QuerySosByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySosByStatusArgs = {
  status: Scalars['String']['input'];
};


export type QuerySosCostArgs = {
  distance: Scalars['Int']['input'];
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};


export type QuerySosCountDaysArgs = {
  days: Scalars['Int']['input'];
};


export type QuerySosCountMonthsArgs = {
  months: Scalars['Int']['input'];
};


export type QuerySosGetAllByUserIdMessagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryUsersCountDaysArgs = {
  days: Scalars['Int']['input'];
};


export type QueryUsersCountMonthsArgs = {
  months: Scalars['Int']['input'];
};

export type RenewMarketplaceItemInput = {
  id: Scalars['ID']['input'];
};

export type Role = {
  __typename?: 'Role';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: RoleType;
};

export enum RoleType {
  Admin = 'ADMIN'
}

export type SosMessage = {
  __typename?: 'SOSMessage';
  created_at: Scalars['DateTime']['output'];
  distance: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  message: Scalars['String']['output'];
  sos_id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type SendMarketplaceItemContactMessageInput = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  shareMyEmail: Scalars['Boolean']['input'];
  shareMyMobile: Scalars['Boolean']['input'];
  shareMyName: Scalars['Boolean']['input'];
};

export type SignUpInput = {
  browser_name: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  location: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  postal_code: Scalars['String']['input'];
  sosReceive: Scalars['Boolean']['input'];
  visitor_id: Scalars['String']['input'];
};

export type Sos = {
  __typename?: 'Sos';
  createdAt: Scalars['DateTime']['output'];
  distance: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isItemPaid?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  paidPrice?: Maybe<Scalars['Int']['output']>;
  paymentBreakdown?: Maybe<PaymentBreakdown>;
  paymentId?: Maybe<Scalars['String']['output']>;
  status: SosStatus;
  surveyFeedback?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  why: SosWhy;
};

export enum SosStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  RefundRequested = 'REFUND_REQUESTED',
  Rejected = 'REJECTED'
}

export enum SosWhy {
  AtHome = 'AT_HOME',
  InHospital = 'IN_HOSPITAL',
  LateStockDelivery = 'LATE_STOCK_DELIVERY',
  OnADayOut = 'ON_A_DAY_OUT',
  OnHoliday = 'ON_HOLIDAY',
  Other = 'OTHER'
}

export type UpdateMeInput = {
  email: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  latitude: Scalars['Float']['input'];
  location: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  sosReceive: Scalars['Boolean']['input'];
  sosReceiveEmail: Scalars['Boolean']['input'];
  sosReceiveMobile: Scalars['Boolean']['input'];
};

export type User = {
  __typename?: 'User';
  browserName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  favouriteMarketplaceItems: Array<Maybe<MarketplaceItem>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  ip?: Maybe<Scalars['String']['output']>;
  isBanned?: Maybe<Scalars['Boolean']['output']>;
  location: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  lockedReason?: Maybe<Scalars['String']['output']>;
  mobile: Scalars['String']['output'];
  mobileVerified: Scalars['Boolean']['output'];
  myMarketplaceItems: Array<Maybe<MarketplaceItem>>;
  mySos: Array<Maybe<Sos>>;
  name: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
  sosReceive: Scalars['Boolean']['output'];
  sosReceiveEmail: Scalars['Boolean']['output'];
  sosReceiveMobile: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  visitorId?: Maybe<Scalars['String']['output']>;
};

export type UserFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductEnquiries = {
  __typename?: 'productEnquiries';
  advert_id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_users: Scalars['String']['output'];
};

export type UserEnquiries = {
  __typename?: 'userEnquiries';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total_product_enquiries: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserMessages = {
  __typename?: 'userMessages';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total_messages: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type AdminSosListContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSosListContainerQuery = { __typename?: 'Query', sosCount?: number | null, sosCountDays?: Array<number | null> | null, sosCountMonths?: Array<number | null> | null, sos: Array<{ __typename?: 'Sos', createdAt: any, distance: number, latitude: number, longitude: number, message: string, status: SosStatus, surveyFeedback?: boolean | null }> };

export type MarketplaceEditContainerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarketplaceEditContainerQuery = { __typename?: 'Query', marketplaceCategories: Array<{ __typename?: 'MarketplaceCategory', id: string, name: string }>, marketplaceItem?: { __typename?: 'MarketplaceItem', bereavement: boolean, condition: MarketplaceItemCondition, delivery?: MarketplaceItemDelivery | null, description: string, expiresOn?: any | null, id: string, location?: string | null, price?: number | null, title: string, status: MarketplaceItemStatus, category?: { __typename?: 'MarketplaceCategory', id: string, name: string } | null, images: Array<{ __typename?: 'Image', id: string, uuid: string, url: string } | null> } | null };

export type MarketplaceEditContainerEditMarketplaceItemMutationVariables = Exact<{
  input: EditMarketplaceItemInput;
}>;


export type MarketplaceEditContainerEditMarketplaceItemMutation = { __typename?: 'Mutation', editMarketplaceItem: { __typename?: 'MarketplaceItem', description: string, id: string, location?: string | null, price?: number | null, title: string, status: MarketplaceItemStatus, images: Array<{ __typename?: 'Image', id: string, uuid: string, url: string } | null> } };

export type MarketplaceMyItemsContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceMyItemsContainerQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, myMarketplaceItems: Array<{ __typename?: 'MarketplaceItem', isPaymentNeeded?: boolean | null, createdAt: any, deleteAt: any, description: string, id: string, isRenewable?: boolean | null, location?: string | null, price?: number | null, status: MarketplaceItemStatus, title: string, category?: { __typename?: 'MarketplaceCategory', id: string, name: string } | null, images: Array<{ __typename?: 'Image', id: string, uuid: string, url: string } | null> } | null> } | null };

export type MarketplaceMyItemsContainerDeleteMarketplaceItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarketplaceMyItemsContainerDeleteMarketplaceItemMutation = { __typename?: 'Mutation', deleteMarketplaceItem?: { __typename?: 'MarketplaceItem', id: string } | null };

export type MarketplaceMyItemsContainerRenewMarketplaceItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarketplaceMyItemsContainerRenewMarketplaceItemMutation = { __typename?: 'Mutation', renewMarketplaceItem?: { __typename?: 'MarketplaceItem', deleteAt: any, id: string, isRenewable?: boolean | null } | null };

export type MarketplaceMyItemsContainerPaidMarketplaceItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  session: Scalars['String']['input'];
  session_id: Scalars['String']['input'];
  price: Scalars['Int']['input'];
}>;


export type MarketplaceMyItemsContainerPaidMarketplaceItemMutation = { __typename?: 'Mutation', paidMarketplaceItem: number };

export type MarketplaceNewContainerCreateMarketplaceItemMutationVariables = Exact<{
  input: CreateMarketplaceItemInput;
}>;


export type MarketplaceNewContainerCreateMarketplaceItemMutation = { __typename?: 'Mutation', createMarketplaceItem: { __typename?: 'MarketplaceItem', id: string } };

export type MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarketplaceNewContainerCheckoutMarketplaceItemMutationMutation = { __typename?: 'Mutation', checkoutMarketplaceItem: string };

export type MarketplaceNewDetailsContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceNewDetailsContainerQuery = { __typename?: 'Query', marketplaceCategories: Array<{ __typename?: 'MarketplaceCategory', id: string, name: string }> };

export type MarketplacePendingContainerQueryVariables = Exact<{
  filter?: InputMaybe<MarketplaceItemsFilterInput>;
}>;


export type MarketplacePendingContainerQuery = { __typename?: 'Query', marketplaceItems: Array<{ __typename?: 'MarketplaceItem', createdAt: any, description: string, id: string, location?: string | null, price?: number | null, status: MarketplaceItemStatus, title: string, paymentUrl?: string | null, category?: { __typename?: 'MarketplaceCategory', id: string, name: string } | null, images: Array<{ __typename?: 'Image', id: string, uuid: string, url: string } | null> }> };

export type MarketplacePendingContainerApproveMarketplaceItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarketplacePendingContainerApproveMarketplaceItemMutation = { __typename?: 'Mutation', approveMarketplaceItem?: { __typename?: 'MarketplaceItem', id: string, status: MarketplaceItemStatus } | null };

export type MarketplacePendingContainerRejectMarketplaceItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketplacePendingContainerRejectMarketplaceItemMutation = { __typename?: 'Mutation', rejectMarketplaceItem?: { __typename?: 'MarketplaceItem', id: string, status: MarketplaceItemStatus } | null };

export type SosEditContainerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SosEditContainerQuery = { __typename?: 'Query', sosById?: { __typename?: 'Sos', id: string, message: string, status: SosStatus } | null };

export type SosEditContainerEditSosItemMutationVariables = Exact<{
  input: EditSosInput;
}>;


export type SosEditContainerEditSosItemMutation = { __typename?: 'Mutation', editSos?: { __typename?: 'Sos', id: string, message: string, status: SosStatus } | null };

export type SosMySosContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type SosMySosContainerQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, mySos: Array<{ __typename?: 'Sos', createdAt: any, distance: number, id: string, message: string, status: SosStatus, isItemPaid?: boolean | null } | null> } | null };

export type SosMySosContainerDeleteSosMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SosMySosContainerDeleteSosMutation = { __typename?: 'Mutation', deleteSos?: { __typename?: 'Sos', id: string } | null };

export type SosMySosContainerRefundRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SosMySosContainerRefundRequestMutation = { __typename?: 'Mutation', refundRequest?: { __typename?: 'Sos', id: string, status: SosStatus } | null };

export type SosMySosContainerRefundMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
}>;


export type SosMySosContainerRefundMutation = { __typename?: 'Mutation', refund?: { __typename?: 'Sos', id: string, status: SosStatus } | null };

export type SosMySosContainerPaidSosMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  session: Scalars['String']['input'];
  session_id: Scalars['String']['input'];
  price: Scalars['Int']['input'];
}>;


export type SosMySosContainerPaidSosMutation = { __typename?: 'Mutation', paidSos: number };

export type SosNewContainerSosCostQueryVariables = Exact<{
  long: Scalars['Float']['input'];
  lat: Scalars['Float']['input'];
  distance: Scalars['Int']['input'];
}>;


export type SosNewContainerSosCostQuery = { __typename?: 'Query', sosCost?: number | null };

export type SosNewContainerCreateSosMutationVariables = Exact<{
  input: CreateSosInput;
}>;


export type SosNewContainerCreateSosMutation = { __typename?: 'Mutation', createSos?: { __typename?: 'Sos', id: string } | null };

export type SosNewContainerCheckoutSosMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SosNewContainerCheckoutSosMutation = { __typename?: 'Mutation', checkoutSos: string };

export type SosPendingContainerQueryVariables = Exact<{
  status: Scalars['String']['input'];
}>;


export type SosPendingContainerQuery = { __typename?: 'Query', sosByStatus: Array<{ __typename?: 'Sos', createdAt: any, distance: number, id: string, message: string, status: SosStatus, isDeleted?: boolean | null, isItemPaid?: boolean | null, paidPrice?: number | null, paymentId?: string | null, paymentBreakdown?: { __typename?: 'PaymentBreakdown', rate: number, total: number, cardFee: number, smsCost: number, twillioGbp: number, twilllioFee: number, potntialTotal: number, twilllioSellingFee: number } | null, user?: { __typename?: 'User', id: string, name: string, email: string, mobile: string, createdAt: any, emailVerified: boolean, location: string, mySos: Array<{ __typename?: 'Sos', createdAt: any, distance: number, id: string, message: string, status: SosStatus, isDeleted?: boolean | null } | null> } | null }> };

export type SosPendingContainerApproveSosMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SosPendingContainerApproveSosMutation = { __typename?: 'Mutation', approveSos?: { __typename?: 'Sos', id: string, status: SosStatus } | null };

export type SosPendingContainerRejectSosMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
}>;


export type SosPendingContainerRejectSosMutation = { __typename?: 'Mutation', rejectSos?: { __typename?: 'Sos', id: string, status: SosStatus } | null };

export type SosRejectedContainerQueryVariables = Exact<{
  status: Scalars['String']['input'];
}>;


export type SosRejectedContainerQuery = { __typename?: 'Query', sosByStatus: Array<{ __typename?: 'Sos', createdAt: any, distance: number, id: string, message: string, status: SosStatus, isDeleted?: boolean | null, isItemPaid?: boolean | null, paidPrice?: number | null, paymentId?: string | null, paymentBreakdown?: { __typename?: 'PaymentBreakdown', rate: number, total: number, cardFee: number, smsCost: number, twillioGbp: number, twilllioFee: number, potntialTotal: number, twilllioSellingFee: number } | null, user?: { __typename?: 'User', id: string, name: string, email: string, mobile: string, createdAt: any, emailVerified: boolean, location: string, mySos: Array<{ __typename?: 'Sos', createdAt: any, distance: number, id: string, message: string, status: SosStatus, isDeleted?: boolean | null } | null> } | null }> };

export type SosRejectedContainerRefundMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
}>;


export type SosRejectedContainerRefundMutation = { __typename?: 'Mutation', refund?: { __typename?: 'Sos', id: string, status: SosStatus } | null };

export type SosPendingContainerSubmitSosSurveyMutationVariables = Exact<{
  token: Scalars['String']['input'];
  feedback: Scalars['Boolean']['input'];
}>;


export type SosPendingContainerSubmitSosSurveyMutation = { __typename?: 'Mutation', submitSosSurvey: boolean };


export const AdminSosListContainerDocument = gql`
    query AdminSosListContainer {
  sos {
    createdAt
    distance
    latitude
    longitude
    message
    status
    surveyFeedback
  }
  sosCount
  sosCountDays(days: 30)
  sosCountMonths(months: 12)
}
    `;

/**
 * __useAdminSosListContainerQuery__
 *
 * To run a query within a React component, call `useAdminSosListContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSosListContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSosListContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminSosListContainerQuery(baseOptions?: Apollo.QueryHookOptions<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>(AdminSosListContainerDocument, options);
      }
export function useAdminSosListContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>(AdminSosListContainerDocument, options);
        }
export function useAdminSosListContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>(AdminSosListContainerDocument, options);
        }
export type AdminSosListContainerQueryHookResult = ReturnType<typeof useAdminSosListContainerQuery>;
export type AdminSosListContainerLazyQueryHookResult = ReturnType<typeof useAdminSosListContainerLazyQuery>;
export type AdminSosListContainerSuspenseQueryHookResult = ReturnType<typeof useAdminSosListContainerSuspenseQuery>;
export type AdminSosListContainerQueryResult = Apollo.QueryResult<AdminSosListContainerQuery, AdminSosListContainerQueryVariables>;
export const MarketplaceEditContainerDocument = gql`
    query MarketplaceEditContainer($id: ID!) {
  marketplaceCategories {
    id
    name
  }
  marketplaceItem(id: $id) {
    bereavement
    category {
      id
      name
    }
    condition
    delivery
    description
    expiresOn
    id
    images {
      id
      uuid
      url
    }
    location
    price
    title
    status
  }
}
    `;

/**
 * __useMarketplaceEditContainerQuery__
 *
 * To run a query within a React component, call `useMarketplaceEditContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceEditContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceEditContainerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceEditContainerQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables> & ({ variables: MarketplaceEditContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables>(MarketplaceEditContainerDocument, options);
      }
export function useMarketplaceEditContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables>(MarketplaceEditContainerDocument, options);
        }
export function useMarketplaceEditContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables>(MarketplaceEditContainerDocument, options);
        }
export type MarketplaceEditContainerQueryHookResult = ReturnType<typeof useMarketplaceEditContainerQuery>;
export type MarketplaceEditContainerLazyQueryHookResult = ReturnType<typeof useMarketplaceEditContainerLazyQuery>;
export type MarketplaceEditContainerSuspenseQueryHookResult = ReturnType<typeof useMarketplaceEditContainerSuspenseQuery>;
export type MarketplaceEditContainerQueryResult = Apollo.QueryResult<MarketplaceEditContainerQuery, MarketplaceEditContainerQueryVariables>;
export const MarketplaceEditContainerEditMarketplaceItemDocument = gql`
    mutation MarketplaceEditContainerEditMarketplaceItem($input: EditMarketplaceItemInput!) {
  editMarketplaceItem(input: $input) {
    description
    id
    images {
      id
      uuid
      url
    }
    location
    price
    title
    status
  }
}
    `;
export type MarketplaceEditContainerEditMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplaceEditContainerEditMarketplaceItemMutation, MarketplaceEditContainerEditMarketplaceItemMutationVariables>;

/**
 * __useMarketplaceEditContainerEditMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplaceEditContainerEditMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceEditContainerEditMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceEditContainerEditMarketplaceItemMutation, { data, loading, error }] = useMarketplaceEditContainerEditMarketplaceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketplaceEditContainerEditMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceEditContainerEditMarketplaceItemMutation, MarketplaceEditContainerEditMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceEditContainerEditMarketplaceItemMutation, MarketplaceEditContainerEditMarketplaceItemMutationVariables>(MarketplaceEditContainerEditMarketplaceItemDocument, options);
      }
export type MarketplaceEditContainerEditMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplaceEditContainerEditMarketplaceItemMutation>;
export type MarketplaceEditContainerEditMarketplaceItemMutationResult = Apollo.MutationResult<MarketplaceEditContainerEditMarketplaceItemMutation>;
export type MarketplaceEditContainerEditMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplaceEditContainerEditMarketplaceItemMutation, MarketplaceEditContainerEditMarketplaceItemMutationVariables>;
export const MarketplaceMyItemsContainerDocument = gql`
    query MarketplaceMyItemsContainer {
  me {
    myMarketplaceItems {
      category {
        id
        name
      }
      isPaymentNeeded
      createdAt
      deleteAt
      description
      id
      images {
        id
        uuid
        url
      }
      isRenewable
      location
      price
      status
      title
    }
    id
  }
}
    `;

/**
 * __useMarketplaceMyItemsContainerQuery__
 *
 * To run a query within a React component, call `useMarketplaceMyItemsContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceMyItemsContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceMyItemsContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketplaceMyItemsContainerQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>(MarketplaceMyItemsContainerDocument, options);
      }
export function useMarketplaceMyItemsContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>(MarketplaceMyItemsContainerDocument, options);
        }
export function useMarketplaceMyItemsContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>(MarketplaceMyItemsContainerDocument, options);
        }
export type MarketplaceMyItemsContainerQueryHookResult = ReturnType<typeof useMarketplaceMyItemsContainerQuery>;
export type MarketplaceMyItemsContainerLazyQueryHookResult = ReturnType<typeof useMarketplaceMyItemsContainerLazyQuery>;
export type MarketplaceMyItemsContainerSuspenseQueryHookResult = ReturnType<typeof useMarketplaceMyItemsContainerSuspenseQuery>;
export type MarketplaceMyItemsContainerQueryResult = Apollo.QueryResult<MarketplaceMyItemsContainerQuery, MarketplaceMyItemsContainerQueryVariables>;
export const MarketplaceMyItemsContainerDeleteMarketplaceItemDocument = gql`
    mutation MarketplaceMyItemsContainerDeleteMarketplaceItem($id: ID!) {
  deleteMarketplaceItem(id: $id) {
    id
  }
}
    `;
export type MarketplaceMyItemsContainerDeleteMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplaceMyItemsContainerDeleteMarketplaceItemMutation, MarketplaceMyItemsContainerDeleteMarketplaceItemMutationVariables>;

/**
 * __useMarketplaceMyItemsContainerDeleteMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplaceMyItemsContainerDeleteMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceMyItemsContainerDeleteMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceMyItemsContainerDeleteMarketplaceItemMutation, { data, loading, error }] = useMarketplaceMyItemsContainerDeleteMarketplaceItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceMyItemsContainerDeleteMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceMyItemsContainerDeleteMarketplaceItemMutation, MarketplaceMyItemsContainerDeleteMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceMyItemsContainerDeleteMarketplaceItemMutation, MarketplaceMyItemsContainerDeleteMarketplaceItemMutationVariables>(MarketplaceMyItemsContainerDeleteMarketplaceItemDocument, options);
      }
export type MarketplaceMyItemsContainerDeleteMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplaceMyItemsContainerDeleteMarketplaceItemMutation>;
export type MarketplaceMyItemsContainerDeleteMarketplaceItemMutationResult = Apollo.MutationResult<MarketplaceMyItemsContainerDeleteMarketplaceItemMutation>;
export type MarketplaceMyItemsContainerDeleteMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplaceMyItemsContainerDeleteMarketplaceItemMutation, MarketplaceMyItemsContainerDeleteMarketplaceItemMutationVariables>;
export const MarketplaceMyItemsContainerRenewMarketplaceItemDocument = gql`
    mutation MarketplaceMyItemsContainerRenewMarketplaceItem($id: ID!) {
  renewMarketplaceItem(id: $id) {
    deleteAt
    id
    isRenewable
  }
}
    `;
export type MarketplaceMyItemsContainerRenewMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplaceMyItemsContainerRenewMarketplaceItemMutation, MarketplaceMyItemsContainerRenewMarketplaceItemMutationVariables>;

/**
 * __useMarketplaceMyItemsContainerRenewMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplaceMyItemsContainerRenewMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceMyItemsContainerRenewMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceMyItemsContainerRenewMarketplaceItemMutation, { data, loading, error }] = useMarketplaceMyItemsContainerRenewMarketplaceItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceMyItemsContainerRenewMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceMyItemsContainerRenewMarketplaceItemMutation, MarketplaceMyItemsContainerRenewMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceMyItemsContainerRenewMarketplaceItemMutation, MarketplaceMyItemsContainerRenewMarketplaceItemMutationVariables>(MarketplaceMyItemsContainerRenewMarketplaceItemDocument, options);
      }
export type MarketplaceMyItemsContainerRenewMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplaceMyItemsContainerRenewMarketplaceItemMutation>;
export type MarketplaceMyItemsContainerRenewMarketplaceItemMutationResult = Apollo.MutationResult<MarketplaceMyItemsContainerRenewMarketplaceItemMutation>;
export type MarketplaceMyItemsContainerRenewMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplaceMyItemsContainerRenewMarketplaceItemMutation, MarketplaceMyItemsContainerRenewMarketplaceItemMutationVariables>;
export const MarketplaceMyItemsContainerPaidMarketplaceItemDocument = gql`
    mutation MarketplaceMyItemsContainerPaidMarketplaceItem($id: ID!, $session: String!, $session_id: String!, $price: Int!) {
  paidMarketplaceItem(
    id: $id
    session: $session
    price: $price
    session_id: $session_id
  )
}
    `;
export type MarketplaceMyItemsContainerPaidMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplaceMyItemsContainerPaidMarketplaceItemMutation, MarketplaceMyItemsContainerPaidMarketplaceItemMutationVariables>;

/**
 * __useMarketplaceMyItemsContainerPaidMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplaceMyItemsContainerPaidMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceMyItemsContainerPaidMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceMyItemsContainerPaidMarketplaceItemMutation, { data, loading, error }] = useMarketplaceMyItemsContainerPaidMarketplaceItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      session: // value for 'session'
 *      session_id: // value for 'session_id'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useMarketplaceMyItemsContainerPaidMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceMyItemsContainerPaidMarketplaceItemMutation, MarketplaceMyItemsContainerPaidMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceMyItemsContainerPaidMarketplaceItemMutation, MarketplaceMyItemsContainerPaidMarketplaceItemMutationVariables>(MarketplaceMyItemsContainerPaidMarketplaceItemDocument, options);
      }
export type MarketplaceMyItemsContainerPaidMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplaceMyItemsContainerPaidMarketplaceItemMutation>;
export type MarketplaceMyItemsContainerPaidMarketplaceItemMutationResult = Apollo.MutationResult<MarketplaceMyItemsContainerPaidMarketplaceItemMutation>;
export type MarketplaceMyItemsContainerPaidMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplaceMyItemsContainerPaidMarketplaceItemMutation, MarketplaceMyItemsContainerPaidMarketplaceItemMutationVariables>;
export const MarketplaceNewContainerCreateMarketplaceItemDocument = gql`
    mutation MarketplaceNewContainerCreateMarketplaceItem($input: CreateMarketplaceItemInput!) {
  createMarketplaceItem(input: $input) {
    id
  }
}
    `;
export type MarketplaceNewContainerCreateMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplaceNewContainerCreateMarketplaceItemMutation, MarketplaceNewContainerCreateMarketplaceItemMutationVariables>;

/**
 * __useMarketplaceNewContainerCreateMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplaceNewContainerCreateMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceNewContainerCreateMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceNewContainerCreateMarketplaceItemMutation, { data, loading, error }] = useMarketplaceNewContainerCreateMarketplaceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketplaceNewContainerCreateMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceNewContainerCreateMarketplaceItemMutation, MarketplaceNewContainerCreateMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceNewContainerCreateMarketplaceItemMutation, MarketplaceNewContainerCreateMarketplaceItemMutationVariables>(MarketplaceNewContainerCreateMarketplaceItemDocument, options);
      }
export type MarketplaceNewContainerCreateMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplaceNewContainerCreateMarketplaceItemMutation>;
export type MarketplaceNewContainerCreateMarketplaceItemMutationResult = Apollo.MutationResult<MarketplaceNewContainerCreateMarketplaceItemMutation>;
export type MarketplaceNewContainerCreateMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplaceNewContainerCreateMarketplaceItemMutation, MarketplaceNewContainerCreateMarketplaceItemMutationVariables>;
export const MarketplaceNewContainerCheckoutMarketplaceItemMutationDocument = gql`
    mutation MarketplaceNewContainerCheckoutMarketplaceItemMutation($id: ID!) {
  checkoutMarketplaceItem(id: $id)
}
    `;
export type MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationFn = Apollo.MutationFunction<MarketplaceNewContainerCheckoutMarketplaceItemMutationMutation, MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationVariables>;

/**
 * __useMarketplaceNewContainerCheckoutMarketplaceItemMutationMutation__
 *
 * To run a mutation, you first call `useMarketplaceNewContainerCheckoutMarketplaceItemMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceNewContainerCheckoutMarketplaceItemMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplaceNewContainerCheckoutMarketplaceItemMutationMutation, { data, loading, error }] = useMarketplaceNewContainerCheckoutMarketplaceItemMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceNewContainerCheckoutMarketplaceItemMutationMutation(baseOptions?: Apollo.MutationHookOptions<MarketplaceNewContainerCheckoutMarketplaceItemMutationMutation, MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplaceNewContainerCheckoutMarketplaceItemMutationMutation, MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationVariables>(MarketplaceNewContainerCheckoutMarketplaceItemMutationDocument, options);
      }
export type MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationHookResult = ReturnType<typeof useMarketplaceNewContainerCheckoutMarketplaceItemMutationMutation>;
export type MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationResult = Apollo.MutationResult<MarketplaceNewContainerCheckoutMarketplaceItemMutationMutation>;
export type MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationOptions = Apollo.BaseMutationOptions<MarketplaceNewContainerCheckoutMarketplaceItemMutationMutation, MarketplaceNewContainerCheckoutMarketplaceItemMutationMutationVariables>;
export const MarketplaceNewDetailsContainerDocument = gql`
    query MarketplaceNewDetailsContainer {
  marketplaceCategories {
    id
    name
  }
}
    `;

/**
 * __useMarketplaceNewDetailsContainerQuery__
 *
 * To run a query within a React component, call `useMarketplaceNewDetailsContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceNewDetailsContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceNewDetailsContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketplaceNewDetailsContainerQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>(MarketplaceNewDetailsContainerDocument, options);
      }
export function useMarketplaceNewDetailsContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>(MarketplaceNewDetailsContainerDocument, options);
        }
export function useMarketplaceNewDetailsContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>(MarketplaceNewDetailsContainerDocument, options);
        }
export type MarketplaceNewDetailsContainerQueryHookResult = ReturnType<typeof useMarketplaceNewDetailsContainerQuery>;
export type MarketplaceNewDetailsContainerLazyQueryHookResult = ReturnType<typeof useMarketplaceNewDetailsContainerLazyQuery>;
export type MarketplaceNewDetailsContainerSuspenseQueryHookResult = ReturnType<typeof useMarketplaceNewDetailsContainerSuspenseQuery>;
export type MarketplaceNewDetailsContainerQueryResult = Apollo.QueryResult<MarketplaceNewDetailsContainerQuery, MarketplaceNewDetailsContainerQueryVariables>;
export const MarketplacePendingContainerDocument = gql`
    query MarketplacePendingContainer($filter: MarketplaceItemsFilterInput) {
  marketplaceItems(filter: $filter) {
    category {
      id
      name
    }
    createdAt
    description
    id
    images {
      id
      uuid
      url
    }
    location
    price
    status
    title
    paymentUrl
  }
}
    `;

/**
 * __useMarketplacePendingContainerQuery__
 *
 * To run a query within a React component, call `useMarketplacePendingContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplacePendingContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplacePendingContainerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMarketplacePendingContainerQuery(baseOptions?: Apollo.QueryHookOptions<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>(MarketplacePendingContainerDocument, options);
      }
export function useMarketplacePendingContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>(MarketplacePendingContainerDocument, options);
        }
export function useMarketplacePendingContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>(MarketplacePendingContainerDocument, options);
        }
export type MarketplacePendingContainerQueryHookResult = ReturnType<typeof useMarketplacePendingContainerQuery>;
export type MarketplacePendingContainerLazyQueryHookResult = ReturnType<typeof useMarketplacePendingContainerLazyQuery>;
export type MarketplacePendingContainerSuspenseQueryHookResult = ReturnType<typeof useMarketplacePendingContainerSuspenseQuery>;
export type MarketplacePendingContainerQueryResult = Apollo.QueryResult<MarketplacePendingContainerQuery, MarketplacePendingContainerQueryVariables>;
export const MarketplacePendingContainerApproveMarketplaceItemDocument = gql`
    mutation MarketplacePendingContainerApproveMarketplaceItem($id: ID!) {
  approveMarketplaceItem(id: $id) {
    id
    status
  }
}
    `;
export type MarketplacePendingContainerApproveMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplacePendingContainerApproveMarketplaceItemMutation, MarketplacePendingContainerApproveMarketplaceItemMutationVariables>;

/**
 * __useMarketplacePendingContainerApproveMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplacePendingContainerApproveMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplacePendingContainerApproveMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplacePendingContainerApproveMarketplaceItemMutation, { data, loading, error }] = useMarketplacePendingContainerApproveMarketplaceItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplacePendingContainerApproveMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplacePendingContainerApproveMarketplaceItemMutation, MarketplacePendingContainerApproveMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplacePendingContainerApproveMarketplaceItemMutation, MarketplacePendingContainerApproveMarketplaceItemMutationVariables>(MarketplacePendingContainerApproveMarketplaceItemDocument, options);
      }
export type MarketplacePendingContainerApproveMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplacePendingContainerApproveMarketplaceItemMutation>;
export type MarketplacePendingContainerApproveMarketplaceItemMutationResult = Apollo.MutationResult<MarketplacePendingContainerApproveMarketplaceItemMutation>;
export type MarketplacePendingContainerApproveMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplacePendingContainerApproveMarketplaceItemMutation, MarketplacePendingContainerApproveMarketplaceItemMutationVariables>;
export const MarketplacePendingContainerRejectMarketplaceItemDocument = gql`
    mutation MarketplacePendingContainerRejectMarketplaceItem($id: ID!, $reason: String!, $feedback: String) {
  rejectMarketplaceItem(id: $id, reason: $reason, feedback: $feedback) {
    id
    status
  }
}
    `;
export type MarketplacePendingContainerRejectMarketplaceItemMutationFn = Apollo.MutationFunction<MarketplacePendingContainerRejectMarketplaceItemMutation, MarketplacePendingContainerRejectMarketplaceItemMutationVariables>;

/**
 * __useMarketplacePendingContainerRejectMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useMarketplacePendingContainerRejectMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketplacePendingContainerRejectMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketplacePendingContainerRejectMarketplaceItemMutation, { data, loading, error }] = useMarketplacePendingContainerRejectMarketplaceItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useMarketplacePendingContainerRejectMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<MarketplacePendingContainerRejectMarketplaceItemMutation, MarketplacePendingContainerRejectMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarketplacePendingContainerRejectMarketplaceItemMutation, MarketplacePendingContainerRejectMarketplaceItemMutationVariables>(MarketplacePendingContainerRejectMarketplaceItemDocument, options);
      }
export type MarketplacePendingContainerRejectMarketplaceItemMutationHookResult = ReturnType<typeof useMarketplacePendingContainerRejectMarketplaceItemMutation>;
export type MarketplacePendingContainerRejectMarketplaceItemMutationResult = Apollo.MutationResult<MarketplacePendingContainerRejectMarketplaceItemMutation>;
export type MarketplacePendingContainerRejectMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<MarketplacePendingContainerRejectMarketplaceItemMutation, MarketplacePendingContainerRejectMarketplaceItemMutationVariables>;
export const SosEditContainerDocument = gql`
    query SosEditContainer($id: ID!) {
  sosById(id: $id) {
    id
    message
    status
  }
}
    `;

/**
 * __useSosEditContainerQuery__
 *
 * To run a query within a React component, call `useSosEditContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSosEditContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSosEditContainerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSosEditContainerQuery(baseOptions: Apollo.QueryHookOptions<SosEditContainerQuery, SosEditContainerQueryVariables> & ({ variables: SosEditContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SosEditContainerQuery, SosEditContainerQueryVariables>(SosEditContainerDocument, options);
      }
export function useSosEditContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SosEditContainerQuery, SosEditContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SosEditContainerQuery, SosEditContainerQueryVariables>(SosEditContainerDocument, options);
        }
export function useSosEditContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SosEditContainerQuery, SosEditContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SosEditContainerQuery, SosEditContainerQueryVariables>(SosEditContainerDocument, options);
        }
export type SosEditContainerQueryHookResult = ReturnType<typeof useSosEditContainerQuery>;
export type SosEditContainerLazyQueryHookResult = ReturnType<typeof useSosEditContainerLazyQuery>;
export type SosEditContainerSuspenseQueryHookResult = ReturnType<typeof useSosEditContainerSuspenseQuery>;
export type SosEditContainerQueryResult = Apollo.QueryResult<SosEditContainerQuery, SosEditContainerQueryVariables>;
export const SosEditContainerEditSosItemDocument = gql`
    mutation SosEditContainerEditSosItem($input: EditSosInput!) {
  editSos(input: $input) {
    id
    message
    status
  }
}
    `;
export type SosEditContainerEditSosItemMutationFn = Apollo.MutationFunction<SosEditContainerEditSosItemMutation, SosEditContainerEditSosItemMutationVariables>;

/**
 * __useSosEditContainerEditSosItemMutation__
 *
 * To run a mutation, you first call `useSosEditContainerEditSosItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosEditContainerEditSosItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosEditContainerEditSosItemMutation, { data, loading, error }] = useSosEditContainerEditSosItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSosEditContainerEditSosItemMutation(baseOptions?: Apollo.MutationHookOptions<SosEditContainerEditSosItemMutation, SosEditContainerEditSosItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosEditContainerEditSosItemMutation, SosEditContainerEditSosItemMutationVariables>(SosEditContainerEditSosItemDocument, options);
      }
export type SosEditContainerEditSosItemMutationHookResult = ReturnType<typeof useSosEditContainerEditSosItemMutation>;
export type SosEditContainerEditSosItemMutationResult = Apollo.MutationResult<SosEditContainerEditSosItemMutation>;
export type SosEditContainerEditSosItemMutationOptions = Apollo.BaseMutationOptions<SosEditContainerEditSosItemMutation, SosEditContainerEditSosItemMutationVariables>;
export const SosMySosContainerDocument = gql`
    query SosMySosContainer {
  me {
    mySos {
      createdAt
      distance
      id
      message
      status
      isItemPaid
    }
    id
  }
}
    `;

/**
 * __useSosMySosContainerQuery__
 *
 * To run a query within a React component, call `useSosMySosContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSosMySosContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSosMySosContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSosMySosContainerQuery(baseOptions?: Apollo.QueryHookOptions<SosMySosContainerQuery, SosMySosContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SosMySosContainerQuery, SosMySosContainerQueryVariables>(SosMySosContainerDocument, options);
      }
export function useSosMySosContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SosMySosContainerQuery, SosMySosContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SosMySosContainerQuery, SosMySosContainerQueryVariables>(SosMySosContainerDocument, options);
        }
export function useSosMySosContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SosMySosContainerQuery, SosMySosContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SosMySosContainerQuery, SosMySosContainerQueryVariables>(SosMySosContainerDocument, options);
        }
export type SosMySosContainerQueryHookResult = ReturnType<typeof useSosMySosContainerQuery>;
export type SosMySosContainerLazyQueryHookResult = ReturnType<typeof useSosMySosContainerLazyQuery>;
export type SosMySosContainerSuspenseQueryHookResult = ReturnType<typeof useSosMySosContainerSuspenseQuery>;
export type SosMySosContainerQueryResult = Apollo.QueryResult<SosMySosContainerQuery, SosMySosContainerQueryVariables>;
export const SosMySosContainerDeleteSosDocument = gql`
    mutation SosMySosContainerDeleteSos($id: ID!) {
  deleteSos(id: $id) {
    id
  }
}
    `;
export type SosMySosContainerDeleteSosMutationFn = Apollo.MutationFunction<SosMySosContainerDeleteSosMutation, SosMySosContainerDeleteSosMutationVariables>;

/**
 * __useSosMySosContainerDeleteSosMutation__
 *
 * To run a mutation, you first call `useSosMySosContainerDeleteSosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosMySosContainerDeleteSosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosMySosContainerDeleteSosMutation, { data, loading, error }] = useSosMySosContainerDeleteSosMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSosMySosContainerDeleteSosMutation(baseOptions?: Apollo.MutationHookOptions<SosMySosContainerDeleteSosMutation, SosMySosContainerDeleteSosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosMySosContainerDeleteSosMutation, SosMySosContainerDeleteSosMutationVariables>(SosMySosContainerDeleteSosDocument, options);
      }
export type SosMySosContainerDeleteSosMutationHookResult = ReturnType<typeof useSosMySosContainerDeleteSosMutation>;
export type SosMySosContainerDeleteSosMutationResult = Apollo.MutationResult<SosMySosContainerDeleteSosMutation>;
export type SosMySosContainerDeleteSosMutationOptions = Apollo.BaseMutationOptions<SosMySosContainerDeleteSosMutation, SosMySosContainerDeleteSosMutationVariables>;
export const SosMySosContainerRefundRequestDocument = gql`
    mutation SosMySosContainerRefundRequest($id: ID!) {
  refundRequest(id: $id) {
    id
    status
  }
}
    `;
export type SosMySosContainerRefundRequestMutationFn = Apollo.MutationFunction<SosMySosContainerRefundRequestMutation, SosMySosContainerRefundRequestMutationVariables>;

/**
 * __useSosMySosContainerRefundRequestMutation__
 *
 * To run a mutation, you first call `useSosMySosContainerRefundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosMySosContainerRefundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosMySosContainerRefundRequestMutation, { data, loading, error }] = useSosMySosContainerRefundRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSosMySosContainerRefundRequestMutation(baseOptions?: Apollo.MutationHookOptions<SosMySosContainerRefundRequestMutation, SosMySosContainerRefundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosMySosContainerRefundRequestMutation, SosMySosContainerRefundRequestMutationVariables>(SosMySosContainerRefundRequestDocument, options);
      }
export type SosMySosContainerRefundRequestMutationHookResult = ReturnType<typeof useSosMySosContainerRefundRequestMutation>;
export type SosMySosContainerRefundRequestMutationResult = Apollo.MutationResult<SosMySosContainerRefundRequestMutation>;
export type SosMySosContainerRefundRequestMutationOptions = Apollo.BaseMutationOptions<SosMySosContainerRefundRequestMutation, SosMySosContainerRefundRequestMutationVariables>;
export const SosMySosContainerRefundDocument = gql`
    mutation SosMySosContainerRefund($id: ID!, $sessionId: String!) {
  refund(id: $id, sessionId: $sessionId) {
    id
    status
  }
}
    `;
export type SosMySosContainerRefundMutationFn = Apollo.MutationFunction<SosMySosContainerRefundMutation, SosMySosContainerRefundMutationVariables>;

/**
 * __useSosMySosContainerRefundMutation__
 *
 * To run a mutation, you first call `useSosMySosContainerRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosMySosContainerRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosMySosContainerRefundMutation, { data, loading, error }] = useSosMySosContainerRefundMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSosMySosContainerRefundMutation(baseOptions?: Apollo.MutationHookOptions<SosMySosContainerRefundMutation, SosMySosContainerRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosMySosContainerRefundMutation, SosMySosContainerRefundMutationVariables>(SosMySosContainerRefundDocument, options);
      }
export type SosMySosContainerRefundMutationHookResult = ReturnType<typeof useSosMySosContainerRefundMutation>;
export type SosMySosContainerRefundMutationResult = Apollo.MutationResult<SosMySosContainerRefundMutation>;
export type SosMySosContainerRefundMutationOptions = Apollo.BaseMutationOptions<SosMySosContainerRefundMutation, SosMySosContainerRefundMutationVariables>;
export const SosMySosContainerPaidSosDocument = gql`
    mutation SosMySosContainerPaidSos($id: ID!, $session: String!, $session_id: String!, $price: Int!) {
  paidSos(id: $id, session: $session, price: $price, session_id: $session_id)
}
    `;
export type SosMySosContainerPaidSosMutationFn = Apollo.MutationFunction<SosMySosContainerPaidSosMutation, SosMySosContainerPaidSosMutationVariables>;

/**
 * __useSosMySosContainerPaidSosMutation__
 *
 * To run a mutation, you first call `useSosMySosContainerPaidSosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosMySosContainerPaidSosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosMySosContainerPaidSosMutation, { data, loading, error }] = useSosMySosContainerPaidSosMutation({
 *   variables: {
 *      id: // value for 'id'
 *      session: // value for 'session'
 *      session_id: // value for 'session_id'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useSosMySosContainerPaidSosMutation(baseOptions?: Apollo.MutationHookOptions<SosMySosContainerPaidSosMutation, SosMySosContainerPaidSosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosMySosContainerPaidSosMutation, SosMySosContainerPaidSosMutationVariables>(SosMySosContainerPaidSosDocument, options);
      }
export type SosMySosContainerPaidSosMutationHookResult = ReturnType<typeof useSosMySosContainerPaidSosMutation>;
export type SosMySosContainerPaidSosMutationResult = Apollo.MutationResult<SosMySosContainerPaidSosMutation>;
export type SosMySosContainerPaidSosMutationOptions = Apollo.BaseMutationOptions<SosMySosContainerPaidSosMutation, SosMySosContainerPaidSosMutationVariables>;
export const SosNewContainerSosCostDocument = gql`
    query SosNewContainerSosCost($long: Float!, $lat: Float!, $distance: Int!) {
  sosCost(long: $long, lat: $lat, distance: $distance)
}
    `;

/**
 * __useSosNewContainerSosCostQuery__
 *
 * To run a query within a React component, call `useSosNewContainerSosCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSosNewContainerSosCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSosNewContainerSosCostQuery({
 *   variables: {
 *      long: // value for 'long'
 *      lat: // value for 'lat'
 *      distance: // value for 'distance'
 *   },
 * });
 */
export function useSosNewContainerSosCostQuery(baseOptions: Apollo.QueryHookOptions<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables> & ({ variables: SosNewContainerSosCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables>(SosNewContainerSosCostDocument, options);
      }
export function useSosNewContainerSosCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables>(SosNewContainerSosCostDocument, options);
        }
export function useSosNewContainerSosCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables>(SosNewContainerSosCostDocument, options);
        }
export type SosNewContainerSosCostQueryHookResult = ReturnType<typeof useSosNewContainerSosCostQuery>;
export type SosNewContainerSosCostLazyQueryHookResult = ReturnType<typeof useSosNewContainerSosCostLazyQuery>;
export type SosNewContainerSosCostSuspenseQueryHookResult = ReturnType<typeof useSosNewContainerSosCostSuspenseQuery>;
export type SosNewContainerSosCostQueryResult = Apollo.QueryResult<SosNewContainerSosCostQuery, SosNewContainerSosCostQueryVariables>;
export const SosNewContainerCreateSosDocument = gql`
    mutation SosNewContainerCreateSos($input: CreateSosInput!) {
  createSos(input: $input) {
    id
  }
}
    `;
export type SosNewContainerCreateSosMutationFn = Apollo.MutationFunction<SosNewContainerCreateSosMutation, SosNewContainerCreateSosMutationVariables>;

/**
 * __useSosNewContainerCreateSosMutation__
 *
 * To run a mutation, you first call `useSosNewContainerCreateSosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosNewContainerCreateSosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosNewContainerCreateSosMutation, { data, loading, error }] = useSosNewContainerCreateSosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSosNewContainerCreateSosMutation(baseOptions?: Apollo.MutationHookOptions<SosNewContainerCreateSosMutation, SosNewContainerCreateSosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosNewContainerCreateSosMutation, SosNewContainerCreateSosMutationVariables>(SosNewContainerCreateSosDocument, options);
      }
export type SosNewContainerCreateSosMutationHookResult = ReturnType<typeof useSosNewContainerCreateSosMutation>;
export type SosNewContainerCreateSosMutationResult = Apollo.MutationResult<SosNewContainerCreateSosMutation>;
export type SosNewContainerCreateSosMutationOptions = Apollo.BaseMutationOptions<SosNewContainerCreateSosMutation, SosNewContainerCreateSosMutationVariables>;
export const SosNewContainerCheckoutSosDocument = gql`
    mutation SosNewContainerCheckoutSos($id: ID!) {
  checkoutSos(id: $id)
}
    `;
export type SosNewContainerCheckoutSosMutationFn = Apollo.MutationFunction<SosNewContainerCheckoutSosMutation, SosNewContainerCheckoutSosMutationVariables>;

/**
 * __useSosNewContainerCheckoutSosMutation__
 *
 * To run a mutation, you first call `useSosNewContainerCheckoutSosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosNewContainerCheckoutSosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosNewContainerCheckoutSosMutation, { data, loading, error }] = useSosNewContainerCheckoutSosMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSosNewContainerCheckoutSosMutation(baseOptions?: Apollo.MutationHookOptions<SosNewContainerCheckoutSosMutation, SosNewContainerCheckoutSosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosNewContainerCheckoutSosMutation, SosNewContainerCheckoutSosMutationVariables>(SosNewContainerCheckoutSosDocument, options);
      }
export type SosNewContainerCheckoutSosMutationHookResult = ReturnType<typeof useSosNewContainerCheckoutSosMutation>;
export type SosNewContainerCheckoutSosMutationResult = Apollo.MutationResult<SosNewContainerCheckoutSosMutation>;
export type SosNewContainerCheckoutSosMutationOptions = Apollo.BaseMutationOptions<SosNewContainerCheckoutSosMutation, SosNewContainerCheckoutSosMutationVariables>;
export const SosPendingContainerDocument = gql`
    query SosPendingContainer($status: String!) {
  sosByStatus(status: $status) {
    createdAt
    distance
    id
    message
    status
    isDeleted
    isItemPaid
    paidPrice
    paymentId
    paymentBreakdown {
      rate
      total
      cardFee
      smsCost
      twillioGbp
      twilllioFee
      potntialTotal
      twilllioSellingFee
    }
    user {
      id
      name
      email
      mobile
      createdAt
      emailVerified
      location
      mySos {
        createdAt
        distance
        id
        message
        status
        isDeleted
      }
    }
  }
}
    `;

/**
 * __useSosPendingContainerQuery__
 *
 * To run a query within a React component, call `useSosPendingContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSosPendingContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSosPendingContainerQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSosPendingContainerQuery(baseOptions: Apollo.QueryHookOptions<SosPendingContainerQuery, SosPendingContainerQueryVariables> & ({ variables: SosPendingContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SosPendingContainerQuery, SosPendingContainerQueryVariables>(SosPendingContainerDocument, options);
      }
export function useSosPendingContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SosPendingContainerQuery, SosPendingContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SosPendingContainerQuery, SosPendingContainerQueryVariables>(SosPendingContainerDocument, options);
        }
export function useSosPendingContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SosPendingContainerQuery, SosPendingContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SosPendingContainerQuery, SosPendingContainerQueryVariables>(SosPendingContainerDocument, options);
        }
export type SosPendingContainerQueryHookResult = ReturnType<typeof useSosPendingContainerQuery>;
export type SosPendingContainerLazyQueryHookResult = ReturnType<typeof useSosPendingContainerLazyQuery>;
export type SosPendingContainerSuspenseQueryHookResult = ReturnType<typeof useSosPendingContainerSuspenseQuery>;
export type SosPendingContainerQueryResult = Apollo.QueryResult<SosPendingContainerQuery, SosPendingContainerQueryVariables>;
export const SosPendingContainerApproveSosDocument = gql`
    mutation SosPendingContainerApproveSos($id: ID!) {
  approveSos(id: $id) {
    id
    status
  }
}
    `;
export type SosPendingContainerApproveSosMutationFn = Apollo.MutationFunction<SosPendingContainerApproveSosMutation, SosPendingContainerApproveSosMutationVariables>;

/**
 * __useSosPendingContainerApproveSosMutation__
 *
 * To run a mutation, you first call `useSosPendingContainerApproveSosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosPendingContainerApproveSosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosPendingContainerApproveSosMutation, { data, loading, error }] = useSosPendingContainerApproveSosMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSosPendingContainerApproveSosMutation(baseOptions?: Apollo.MutationHookOptions<SosPendingContainerApproveSosMutation, SosPendingContainerApproveSosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosPendingContainerApproveSosMutation, SosPendingContainerApproveSosMutationVariables>(SosPendingContainerApproveSosDocument, options);
      }
export type SosPendingContainerApproveSosMutationHookResult = ReturnType<typeof useSosPendingContainerApproveSosMutation>;
export type SosPendingContainerApproveSosMutationResult = Apollo.MutationResult<SosPendingContainerApproveSosMutation>;
export type SosPendingContainerApproveSosMutationOptions = Apollo.BaseMutationOptions<SosPendingContainerApproveSosMutation, SosPendingContainerApproveSosMutationVariables>;
export const SosPendingContainerRejectSosDocument = gql`
    mutation SosPendingContainerRejectSos($id: ID!, $reason: String!, $feedback: String!) {
  rejectSos(id: $id, reason: $reason, feedback: $feedback) {
    id
    status
  }
}
    `;
export type SosPendingContainerRejectSosMutationFn = Apollo.MutationFunction<SosPendingContainerRejectSosMutation, SosPendingContainerRejectSosMutationVariables>;

/**
 * __useSosPendingContainerRejectSosMutation__
 *
 * To run a mutation, you first call `useSosPendingContainerRejectSosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosPendingContainerRejectSosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosPendingContainerRejectSosMutation, { data, loading, error }] = useSosPendingContainerRejectSosMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSosPendingContainerRejectSosMutation(baseOptions?: Apollo.MutationHookOptions<SosPendingContainerRejectSosMutation, SosPendingContainerRejectSosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosPendingContainerRejectSosMutation, SosPendingContainerRejectSosMutationVariables>(SosPendingContainerRejectSosDocument, options);
      }
export type SosPendingContainerRejectSosMutationHookResult = ReturnType<typeof useSosPendingContainerRejectSosMutation>;
export type SosPendingContainerRejectSosMutationResult = Apollo.MutationResult<SosPendingContainerRejectSosMutation>;
export type SosPendingContainerRejectSosMutationOptions = Apollo.BaseMutationOptions<SosPendingContainerRejectSosMutation, SosPendingContainerRejectSosMutationVariables>;
export const SosRejectedContainerDocument = gql`
    query SosRejectedContainer($status: String!) {
  sosByStatus(status: $status) {
    createdAt
    distance
    id
    message
    status
    isDeleted
    isItemPaid
    paidPrice
    paymentId
    paymentBreakdown {
      rate
      total
      cardFee
      smsCost
      twillioGbp
      twilllioFee
      potntialTotal
      twilllioSellingFee
    }
    user {
      id
      name
      email
      mobile
      createdAt
      emailVerified
      location
      mySos {
        createdAt
        distance
        id
        message
        status
        isDeleted
      }
    }
  }
}
    `;

/**
 * __useSosRejectedContainerQuery__
 *
 * To run a query within a React component, call `useSosRejectedContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSosRejectedContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSosRejectedContainerQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSosRejectedContainerQuery(baseOptions: Apollo.QueryHookOptions<SosRejectedContainerQuery, SosRejectedContainerQueryVariables> & ({ variables: SosRejectedContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SosRejectedContainerQuery, SosRejectedContainerQueryVariables>(SosRejectedContainerDocument, options);
      }
export function useSosRejectedContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SosRejectedContainerQuery, SosRejectedContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SosRejectedContainerQuery, SosRejectedContainerQueryVariables>(SosRejectedContainerDocument, options);
        }
export function useSosRejectedContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SosRejectedContainerQuery, SosRejectedContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SosRejectedContainerQuery, SosRejectedContainerQueryVariables>(SosRejectedContainerDocument, options);
        }
export type SosRejectedContainerQueryHookResult = ReturnType<typeof useSosRejectedContainerQuery>;
export type SosRejectedContainerLazyQueryHookResult = ReturnType<typeof useSosRejectedContainerLazyQuery>;
export type SosRejectedContainerSuspenseQueryHookResult = ReturnType<typeof useSosRejectedContainerSuspenseQuery>;
export type SosRejectedContainerQueryResult = Apollo.QueryResult<SosRejectedContainerQuery, SosRejectedContainerQueryVariables>;
export const SosRejectedContainerRefundDocument = gql`
    mutation SosRejectedContainerRefund($id: ID!, $sessionId: String!) {
  refund(id: $id, sessionId: $sessionId) {
    id
    status
  }
}
    `;
export type SosRejectedContainerRefundMutationFn = Apollo.MutationFunction<SosRejectedContainerRefundMutation, SosRejectedContainerRefundMutationVariables>;

/**
 * __useSosRejectedContainerRefundMutation__
 *
 * To run a mutation, you first call `useSosRejectedContainerRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosRejectedContainerRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosRejectedContainerRefundMutation, { data, loading, error }] = useSosRejectedContainerRefundMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSosRejectedContainerRefundMutation(baseOptions?: Apollo.MutationHookOptions<SosRejectedContainerRefundMutation, SosRejectedContainerRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosRejectedContainerRefundMutation, SosRejectedContainerRefundMutationVariables>(SosRejectedContainerRefundDocument, options);
      }
export type SosRejectedContainerRefundMutationHookResult = ReturnType<typeof useSosRejectedContainerRefundMutation>;
export type SosRejectedContainerRefundMutationResult = Apollo.MutationResult<SosRejectedContainerRefundMutation>;
export type SosRejectedContainerRefundMutationOptions = Apollo.BaseMutationOptions<SosRejectedContainerRefundMutation, SosRejectedContainerRefundMutationVariables>;
export const SosPendingContainerSubmitSosSurveyDocument = gql`
    mutation SosPendingContainerSubmitSosSurvey($token: String!, $feedback: Boolean!) {
  submitSosSurvey(token: $token, feedback: $feedback)
}
    `;
export type SosPendingContainerSubmitSosSurveyMutationFn = Apollo.MutationFunction<SosPendingContainerSubmitSosSurveyMutation, SosPendingContainerSubmitSosSurveyMutationVariables>;

/**
 * __useSosPendingContainerSubmitSosSurveyMutation__
 *
 * To run a mutation, you first call `useSosPendingContainerSubmitSosSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSosPendingContainerSubmitSosSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sosPendingContainerSubmitSosSurveyMutation, { data, loading, error }] = useSosPendingContainerSubmitSosSurveyMutation({
 *   variables: {
 *      token: // value for 'token'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSosPendingContainerSubmitSosSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SosPendingContainerSubmitSosSurveyMutation, SosPendingContainerSubmitSosSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SosPendingContainerSubmitSosSurveyMutation, SosPendingContainerSubmitSosSurveyMutationVariables>(SosPendingContainerSubmitSosSurveyDocument, options);
      }
export type SosPendingContainerSubmitSosSurveyMutationHookResult = ReturnType<typeof useSosPendingContainerSubmitSosSurveyMutation>;
export type SosPendingContainerSubmitSosSurveyMutationResult = Apollo.MutationResult<SosPendingContainerSubmitSosSurveyMutation>;
export type SosPendingContainerSubmitSosSurveyMutationOptions = Apollo.BaseMutationOptions<SosPendingContainerSubmitSosSurveyMutation, SosPendingContainerSubmitSosSurveyMutationVariables>;